<template>
    <table border="1">
        <tr>
            <!-- 操作-->
            <div style="height:400px;">
                <div id="bar_dv"
                     ref="chart" style="height:300px;margin-top:40px;" height="400"></div>
            </div>
        </tr>
    </table>
</template>

<script>
    import moment from 'moment'

    export default {
        name: "EchartsTest",
        props: ["actID", "status", "act_status"],
        data() {
            return {}
        },
        mounted() {
            this.drawLine();
        },
        methods: {
            drawLine() {
                // 基于准备好的dom，初始化echarts实例
                //var bar_dv = document.getElementById('bar_dv');
                var bar_dv = this.$refs.chart;
                if (bar_dv) {
                    console.log('bar_dv不为空');
                    let myChart = this.$echarts.init(bar_dv)
                    myChart.setOption({
                        title: { text: '销售情况' },
                        tooltip: {
                            trigger: 'axis'
                        },
                        toolbox: {
                            show: false,
                            feature: {
                                mark: {show: true},
                                dataView: {show: true, readOnly: false},
                                magicType: {show: true, type: ['line', 'bar']},
                                restore: {show: true},
                                saveAsImage: {show: true}
                            }
                        },
                        calculable: true,
                        legend: {
                            data: ['蒸发量', '降水量', '平均温度']
                        },
                        xAxis: [
                            {
                                type: 'category',
                                data: ['1月', '2月', '3月', '4月', '5月', '6月',
                                    '7月', '8月', '9月', '10月', '11月', '12月']
                            }
                        ],
                        yAxis: [
                            {
                                type: 'value',
                                name: '水量',
                                axisLabel: {
                                    formatter: '{value} ml'
                                }
                            },
                            {
                                type: 'value',
                                name: '温度',
                                axisLabel: {
                                    formatter: '{value} °C'
                                }
                            }
                        ],
                        series: [

                            {
                                name: '蒸发量',
                                type: 'bar',
                                data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3]
                            },
                            {
                                name: '降水量',
                                type: 'line',
                                data: [2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3]
                            },
                            {
                                name: '平均温度',
                                type: 'line',
                                yAxisIndex: 1,
                                data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2]
                            }
                        ]
                    });
                }else {
                    console.log('bar_dv为空!');
                }
              }
        },
    }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// EchartsTest.vue?5226cb3d